import './styles/Footer.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-wrapper">
      <div className="footer-main">
        {/* About Section */}
        <div className="footer-column about-box">
          <h2 className="footer-logo">Visionary Visa <span>Consulting</span></h2>
          <p>
            We make global mobility seamless. From quick advice to handling complex 
            visa paperwork, we ensure you’re ready for your next international 
            milestone. Let us handle the bureaucracy while you focus on the journey.
          </p>
        </div>

        {/* Contacts Section */}
        <div className="footer-column">
          <h3>Contact Our Agents</h3>
          <div className="agent-item">
            <h4>Tatenda</h4>
            <a href="mailto:tatenda@visionaryvisaconsulting.co.za">tatenda@visionaryvisaconsulting.co.za</a>
            <div className="agent-links">
              <a href="https://wa.me/+27720663578" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-whatsapp"></i> WhatsApp
              </a>
              <span>+27 72 066 3578</span>
            </div>
          </div>
          <div className="agent-item">
            <h4>Henry</h4>
            <a href="mailto:henry@visionaryvisaconsulting.co.za">henry@visionaryvisaconsulting.co.za</a>
            <div className="agent-links">
              <a href="https://wa.me/+27642256536" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-whatsapp"></i> WhatsApp
              </a>
              <span>+27 64 225 6536</span>
            </div>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-column">
          <h3>Quick Navigation</h3>
          <ul className="footer-links">
            <li onClick={() => navigate('/')}>Home</li>
            <li onClick={() => navigate('/services')}>Our Services</li>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/contact')}>Get In Touch</li>
            <li>
              <a href="mailto:info@visionaryvisaconsultation.co.za">General Inquiry</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="bottom-content">
          <p>&copy; {new Date().getFullYear()} Visionary Visa Consultant. All rights reserved.</p>
          <p className="credits">
            Done by <a href="https://nateanne.co.za" target="_blank" rel="noreferrer">nate~anne</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
